export var getMainImage = function (media) {
    return media.find(function (item) { return item.type === 'image'; });
};
export var getImageUrls = function (image, defaultSize) {
    return {
        src: image.urls[defaultSize].L,
        srcSet: "\n    ".concat(image.urls['1x1'].L, " 400w,\n    ").concat(image.urls['4x3'].L, " 800w,\n    ").concat(image.urls['16x9'].L, " 1024w\n    "),
    };
};
export var getMainImageUrls = function (media, defaultSize) {
    if (media) {
        var mainImage = getMainImage(media);
        if (mainImage) {
            return getImageUrls(mainImage, defaultSize);
        }
    }
    return undefined;
};
